import React from 'react';
import styled from 'styled-components';
import { media } from 'helpers/MediaHelper';
import { colors } from 'helpers/ColorHelper';

import PillButton from 'components/ui/Buttons/PillButton';

const CardBase = styled.div`
  color: ${colors.DARKEST_GRAY};
  border-radius: 20px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.125);
  text-align: left;
  padding: 24px 24px 16px 24px;
  background: ${colors.WHITE};

  ${media.mobile`
    padding: 16px;
  `};
`;

const Card = styled(CardBase)`
  margin-top: 32px;
  display: flex;
  flex-flow: column;
  text-align: center;
`;

const BoldTitle = styled.p`
  font-weight: 500;
  font-size: 24px;
  margin: 0;
  color: ${colors.BLACK_RUSSIAN};
`;

const GreyText = styled.p`
  margin: 16px 0 0 0;
  font-size: 16px;
  color: ${colors.CHAR_COUNT};
`;

const StyledPillButton = styled(PillButton)`
  margin: 24px auto 0px;
`;

const OptionDetails = ({
  optionsTitle,
  optionDetails,
  optionTrigger,
  buttonVerbiage,
  disabled,
}) => {
  return (
    <Card>
      <div>
        <BoldTitle>{optionsTitle}</BoldTitle>
      </div>

      <GreyText>{optionDetails}</GreyText>

      <StyledPillButton disabled={disabled} onClick={optionTrigger}>
        {buttonVerbiage}
      </StyledPillButton>
    </Card>
  );
};

export default OptionDetails;
